import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="videos"
export default class extends Controller {
  connect() {
  }

  static get targets() {
    return ["explicit", "cleaned", "cleanedinput", "ratedforspotify", "ratedforspotifyinput", "ratingagency", "ratingagencyinput", "ratingtext", "ratingtextinput", "ratedby", "ratedbyinput"]
  }

  explicit() {
    const explicitValue = this.explicitTarget.checked;
    console.log('explicitValue = ' + explicitValue);

    if(explicitValue === true){
      this.cleanedinputTarget.hidden = false;
      this.ratedbyTarget.hidden = false;
      this.ratedbyinputTarget.hidden = false;

    } else {
      this.ratedforspotifyTarget.checked = false;

      this.ratedbyTarget.value = '';
      this.ratedbyTarget.hidden = true;

      this.cleanedTarget.checked = false;
      this.cleanedinputTarget.hidden = true;

      this.ratingagencyTarget.value = '';
      this.ratingagencyinputTarget.hidden = true;

      this.ratingtextTarget.value = '';
      this.ratingtextinputTarget.hidden = true;
      
      this.ratedbyinputTarget.hidden = true;
    }
  }

  ratedby(){
    const ratedByValue = this.ratedbyTarget.value;

    this.ratingagencyTarget.value = '';
    this.ratingtextTarget.value = '';

    if (ratedByValue === 'distributor') {
      this.ratingagencyinputTarget.hidden = true;
      this.ratingtextinputTarget.hidden = true;
      this.ratedforspotifyTarget.checked = true;

      return;
    }

    if (ratedByValue === 'agency') {
      this.ratingagencyinputTarget.hidden = false;
      this.ratingtextinputTarget.hidden = false;
      this.ratedforspotifyTarget.checked = false;

      return;
    }

    this.ratingagencyinputTarget.hidden = true;
    this.ratingtextinputTarget.hidden = true;
    
    this.ratedforspotifyTarget.checked = false;
  }
}
